import { EmbeddedCheckout } from '@stripe/react-stripe-js'
import { forwardRef, useImperativeHandle, useState } from 'react'
import Modal from 'react-modal'

Modal.setAppElement('body')

const StripeCheckoutModal = forwardRef(
  ({ handleNewEventClicked = null }, ref) => {
    const [isOpen, setIsOpen] = useState(false)

    useImperativeHandle(ref, () => ({
      open(handleNewEventClicked) {
        setIsOpen(true)
      },
    }))

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={{
          content: {
            maxWidth: '1500px',
            maxHeight: '800px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '50px',
            marginBottom: 'auto',
          },
          overlay: {
            backgroundColor: 'transparent',
            backdropFilter: 'blur(10px)',
          },
        }}
      >
        <EmbeddedCheckout />
      </Modal>
    )
  },
)

export default StripeCheckoutModal
